module.exports = __webpack_public_path__ + "img/logo-icon.456294df.jpg";